import React from 'react'
import Section from '../Section'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import cn from 'classnames'
import s from './BenefitsList.scss'
import { Row, Col } from 'components/Layout'

export default props => (
  <Section
    color={props.color}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
    style={{ textAlign: 'center' }}
  >
    <h3 className={cn(sText.heading3, sText.primary)}>{props.title}</h3>
    <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-col'])}>
      {props.items.map((item, idx) => (
        <Col
          key={idx}
          className={cn(sLay['flex-gt-xs-33'])}
          style={{ marginTop: '50px', marginBottom: '50px' }}
        >
          <img style={{ maxWidth: '50%' }} src={item.fields.icon.fields.file.url} />
          <h4 className={s['item-title']}>{item.fields.title}</h4>
          <div className={s['item-text']}>{item.fields.text}</div>
        </Col>
      ))}
    </Row>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BenefitsList/BenefitsList.jsx